import React from 'react';

const Alianza = () => {
  return (
    <div>
      <h4>Alianza for VOIP Customers</h4>
    </div>
  );
};

export default Alianza;
